/**
 * Layout-only parent route for /team/*.
 *
 * "Team" is the operational view of the org: a list of employees and a
 * per-employee task tracker (open deals / follow-ups, contacts owned,
 * recent completions). It's distinct from /reports — Reports is the
 * analytics/numbers view, Team is the "what is this person actually
 * working on right now" view. They deep-link into each other where it
 * helps but each lives under its own nav.
 *
 * Manager+ only. The role gate is duplicated on every child route so
 * deep links can't bypass it; the server enforces it too via the
 * /api/users gate.
 */

import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

import { useAuthStore } from "../lib/auth";

export const Route = createFileRoute("/_app/team")({
  beforeLoad: () => {
    const user = useAuthStore.getState().user;
    if (user && user.role !== "admin" && user.role !== "manager") {
      throw redirect({ to: "/deals" });
    }
  },
  component: TeamLayout,
});

function TeamLayout() {
  return <Outlet />;
}
